import { env, appVersion, apiBaseUrl, runtimeVersion } from "@constants/Env";
import { Platform } from "react-native";
import * as Device from "expo-device";
import axios from "axios";
import ExceptionError from "@lib/errors/exceptionError";
import { SecureStoreManager } from "@lib/util/secureStoreManager";

type SeverityLevel = "fatal" | "error" | "warning" | "log" | "info" | "debug";

// Sentry 削除後も既存の呼び出しを残すため、空実装にする。
export function log(
  _level: SeverityLevel,
  _exception: unknown,
  _captureContext?: unknown
) {}

export async function sendError(
  _error: ExceptionError,
  _captureContext?: { extra: Record<string, unknown> }
) {}

export type NotificationLevel =
  | "error"
  | "warning"
  | "info"
  | "debug"
  | "monitor";

interface NotificationOptions {
  level?: NotificationLevel;
  skipDeviceInfo?: boolean;
}

export async function notify(data: any, options: NotificationOptions = {}) {
  const { level = "error", skipDeviceInfo = false } = options;

  if (!apiBaseUrl) {
    console.error("API base URL is not configured");
    return;
  }

  try {
    const deviceInfo = skipDeviceInfo
      ? undefined
      : {
          os: Device.osName,
          osVersion: Device.osVersion,
          modelName: Device.modelName,
          platform: Platform.OS,
          env,
          appVersion,
          runtimeVersion,
        };

    // Authorizationヘッダーを取得（RelayEnvironmentと同じ方法を使用）
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    try {
      const authToken = await SecureStoreManager.getAccessToken();
      if (authToken !== null) {
        headers["Authorization"] = `Bearer ${authToken}`;
      }
    } catch (storageError) {
      // ストレージアクセスエラーは無視（認証なしでリクエスト）
      console.warn("Failed to get auth token:", storageError);
    }

    // dataが文字列の場合はオブジェクトにラップ
    const formattedData = typeof data === "string" ? { message: data } : data;

    await axios.post(
      `${apiBaseUrl}/api/v1/frontend_logs`,
      {
        frontend_log: {
          level,
          data: formattedData,
          device_info: deviceInfo,
        },
      },
      { headers }
    );
  } catch (e) {
    console.error(`Failed to send frontend log (${level}):`, e);
  }
}

// 後方互換性のため、エラー専用の関数もエクスポート
export async function notifyError(error: any) {
  return notify(error, { level: "error" });
}
